import * as React from 'react';
import PolicyPage from '../policy/PolicyPage';
import { usePolicyText, getPolicyTextUrl, getPolicyPdfUrl } from '../policy/usePolicyText';

/** Azure Blob or other URL for terms text. Fallback: local /policies/terms.txt */
const TERMS_TEXT_URL = getPolicyTextUrl(
  process.env.REACT_APP_TERMS_TEXT_URL,
  '/policies/terms.txt'
);

/** Azure Blob or other URL for terms PDF. Fallback: local /terms.pdf */
const TERMS_PDF_URL = getPolicyPdfUrl(
  process.env.REACT_APP_TERMS_PDF_URL,
  '/policies/terms.pdf'
);

export default function TermsPage() {
  const { content, loading, error } = usePolicyText(TERMS_TEXT_URL);

  return (
    <PolicyPage
      title="Terms and Conditions"
      content={content}
      loading={loading}
      error={error}
      pdfUrl={TERMS_PDF_URL}
    />
  );
}
